import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import _ from 'lodash';
import Sortable from 'react-sortablejs';
import Tooltip from "@material-ui/core/Tooltip";
import DragHandle from "@material-ui/icons/DragHandle";
import Grid from "@material-ui/core/Grid";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    positionInput: {
        width: 50
    }
});

class CollectionMomentPlaylists extends Component {


    constructor(props) {
        super(props);
    }

    render() {

        const {classes, theme} = this.props;
        let sortable = null;

        return (<Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Moment Playlist ID</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Position</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>


                    <Sortable
                        options={{handle: '.handler'}}
                        ref={(c) => {
                            if (c) {
                                sortable = c.sortable;
                            }
                        }}
                        tag={'tbody'}
                        onChange={(order, sortable, evt) => {
                            this.props.onChange(order);
                        }}
                    >
                        {_.map(this.props.contents, ((row, index) => (
                            <TableRow key={index} data-id={row.contentId}>
                                <TableCell>{row.contentId}</TableCell>
                                <TableCell>{row.title}</TableCell>
                                <TableCell>{row.position}</TableCell>
                                <TableCell>

                                    <Grid container spacing={0} direction="row" justify="space-between" alignItems={"center"}>

                                    <Tooltip item xs={6} title="Drag this to reorder" aria-label="Drag this to reorder">
                                        <IconButton onClick={(event) => {
                                            event.preventDefault()
                                        }} class={'handler MuiButtonBase-root MuiIconButton-root'}>

                                            <DragHandle fontSize={"small"} className={classes.dragDropIcon}/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip item xs={6} title="Remove Moments Playlist" aria-label="Remove Moments Playlist from this collection.">
                                        <IconButton aria-label="delete"
                                                    onClick={this.props.removeMomentPlaylist.bind(this, row.contentId, row.id)}
                                                    className={classes.button}>
                                            <DeleteIcon fontSize="small"/>
                                        </IconButton>
                                    </Tooltip>
                                    </Grid>
                                </TableCell>
                            </TableRow>

                        )))}

                    </Sortable>

                </Table>
            </Paper>
        )
    };
}


export default (withStyles(styles, {withTheme: true})(CollectionMomentPlaylists));